import { AppSettings } from "../hooks/settings/settings";
import { ApiService } from "./api-service";


export interface VersionSettings {
    version: string;
    releaseDate: string;
}

export class ServerVersionService {

    public async load(settings?: AppSettings): Promise<VersionSettings> {

//settings?.production && 

        if (settings?.fabrixServer) {
            let url = ApiService.cleanUrl(`${settings.fabrixServer}/settings/version`)
            const rep = await fetch(url, { method: 'GET' });
            let text = await rep.text();
            let data = await ApiService.deserialize(text);
            if (data && data.version) {
                let ver = data.version;
                let date = new Date(data.releaseDate);

                return {
                    version: ver,
                    releaseDate: date.toJSON()
                }
            }
        }
         return {
             version: 'DEBUG',
             releaseDate: (new Date()).toJSON()
         }
    }

}